"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStars = void 0;
const setStars = (rating, starIcons) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
            stars.push(starIcons[4]);
        }
        else if (Math.trunc(rating) + 1 < i) {
            stars.push(starIcons[0]);
        }
        else {
            const index = Math.floor((rating % 1) / 0.25);
            stars.push(starIcons[index]);
        }
    }
    return stars;
};
exports.setStars = setStars;
